module.exports = __webpack_public_path__ + "static/media/contentresan-tutorial.8774e17c.jpg";